const DesktopAppBanner = () => (
  <a
    href="https://app.mysolon.gr"
    target="_blank"
    rel="noopener"
    className="desktop-app-banner"
    aria-label="Κατεβάστε τη νέα Desktop εφαρμογή MySolon"
  >
    <span className="desktop-app-banner__pattern" aria-hidden="true" />
    <span className="desktop-app-banner__shimmer" aria-hidden="true" />
    <span className="desktop-app-banner__icon" aria-hidden="true">
      <img
        src="/images/mysolon-desktop-icon.png"
        alt=""
        className="desktop-app-banner__icon-img"
        loading="lazy"
      />
    </span>
    <span className="desktop-app-banner__copy">
      <span className="desktop-app-banner__title">
        MySolon <em>Desktop</em>
        <span className="desktop-app-banner__pill">
          <span className="desktop-app-banner__pill-dot" aria-hidden="true" />
          ΝΕΟ
        </span>
      </span>
      <span className="desktop-app-banner__subtitle">
        Αυτόματη παρακολούθηση υποθέσεων &middot; Δωρεάν λήψη
      </span>
    </span>
    <span className="desktop-app-banner__arrow" aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 12h14M13 6l6 6-6 6" />
      </svg>
    </span>
  </a>
);

export default DesktopAppBanner;
